export const ArgyleIncomeVerificationFormTestIds = {
  REPORT_TYPE_SELECT: 'argyle-income-verification-form.report-type-select',
};
